export const template_0005 = `
<div class="all-floors-scroll-wrapper no-scrollbar" style="width:100%;overflow-x:auto;box-sizing:border-box;">
    <style>
        .no-scrollbar {
            overflow: auto;
            scrollbar-width: none;
            /* Firefox */
            -ms-overflow-style: none;
            /* IE 10+ */
        }

        /* Ẩn scrollbar trên Chrome, Safari */
        .no-scrollbar::-webkit-scrollbar {
            display: none;
            width: 0px;
            height: 0px;
        }

        .left-part {
            width: 30vw;
            height: 100%;
            display: block;
            opacity: 0;
        }

        .right-part {
            width: 50vw;
            height: 100%;
            display: block;
            opacity: 0;
        }
    </style>
    <div class="all-floors-inner floor-guide-drag-container"
        style="width:104.3333333334vw;display:flex;box-sizing:border-box;">
        <div class="left-part">1</div>
        <div class="floor-guide-floors" id="departmentstore">
            <div class="floor-guide-mall-name">
                <div class="floor-guide-mall-name-tts">본관</div>
            </div>
            <div class="floor-guide-floor" data-id="FL-rpT-fhv3P9135" data-x="1556" data-y="1490">
                <span class="floor-guide-floor-name english">11F</span>
                <span class="floor-guide-floor-desc">문화센터ㅣ샤롯데가든</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-wJRFxZcroK8942" data-x="1556" data-y="1490">
                <span class="floor-guide-floor-name english">10F</span>
                <span class="floor-guide-floor-desc">롯데시네마ㅣ샤롯데가든</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-PNIkOls4re8745" data-x="1556" data-y="1490">
                <span class="floor-guide-floor-name english">9F</span>
                <span class="floor-guide-floor-desc">식당가ㅣ삼성ㅣ애플, 투바ㅣ엘아레나ㅣ롯데카드</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-trVCwptiCO8567" data-x="1556" data-y="1490">
                <span class="floor-guide-floor-name english">8F</span>
                <span class="floor-guide-floor-desc">면세점</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-2EVzlBClle8385" data-x="1556" data-y="1490">
                <span class="floor-guide-floor-name english">7F</span>
                <span class="floor-guide-floor-desc">영스트릿ㅣ사은행사장</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-_m6R1e7H-8199" data-x="1556" data-y="1490">
                <span class="floor-guide-floor-name english">6F</span>
                <span class="floor-guide-floor-desc">가정용품ㅣ가전ㅣ아동ㆍ유아</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-AW498GbDBo8019" data-x="1556" data-y="1490">
                <span class="floor-guide-floor-name english">5F</span>
                <span class="floor-guide-floor-desc">아웃도어ㅣ스포츠</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-PHI5VPcEfv7856" data-x="1556" data-y="1490">
                <span class="floor-guide-floor-name english">4F</span>
                <span class="floor-guide-floor-desc">남성패션ㅣ골프</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--has-right" data-id="FL--jdXZ5MmPB7683" data-x="1556"
                data-y="1490">
                <span class="floor-guide-floor-name english">3F</span>
                <span class="floor-guide-floor-desc">여성패션ㅣ구두ㅣ핸드백</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--has-right" data-id="FL-O4B-UIG4s7511" data-x="1556"
                data-y="1490">
                <span class="floor-guide-floor-name english">2F</span>
                <span class="floor-guide-floor-desc">여성캐주얼ㅣ란제리</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--has-right" data-id="FL-G-f599ULu6387" data-x="1556"
                data-y="1490">
                <span class="floor-guide-floor-name english">1F</span>
                <span class="floor-guide-floor-desc">화장품ㅣ해외패션</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--has-right" data-id="FL-0P6K64skLY9316" data-x="1556"
                data-y="1490">
                <span class="floor-guide-floor-name english">B1</span>
                <span class="floor-guide-floor-desc">델리ㅣ패션잡화ㅣ점행사장</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-PjVlevDuSV9511" data-x="1556" data-y="1490">
                <span class="floor-guide-floor-name english">B2</span>
                <span class="floor-guide-floor-desc">식품관 푸드에비뉴</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--gray" data-id="FL-qZx08C1c429721" data-x="3430"
                data-y="2000">
                <span class="floor-guide-floor-name english">B3-B5</span>
                <span class="floor-guide-floor-desc">주차장</span>
            </div>
        </div>
        <div class="floor-guide-floors" id="avenuel">
            <div class="floor-guide-mall-name">
                <div class="floor-guide-mall-name-tts">에비뉴엘</div>
            </div>
            <div class="floor-guide-floor" data-id="" data-x="2356" data-y="1490">
                <span class="floor-guide-floor-name english">M3F</span>
                <span class="floor-guide-floor-desc">Parking lot</span>
            </div>
            <div class="floor-guide-floor" data-id="FL--jdXZ5MmPB7683" data-x="2356" data-y="1490">
                <span class="floor-guide-floor-name english">2F</span>
                <span class="floor-guide-floor-desc">해외패션</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-O4B-UIG4s7511" data-x="2356" data-y="1490">
                <span class="floor-guide-floor-name english">1F</span>
                <span class="floor-guide-floor-desc">해외시계ㆍ보석</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-G-f599ULu6387" data-x="2356" data-y="1490">
                <span class="floor-guide-floor-name english">MF</span>
                <span class="floor-guide-floor-desc">해외명품</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-0P6K64skLY9316" data-x="2356" data-y="1490">
                <span class="floor-guide-floor-name english">GF</span>
                <span class="floor-guide-floor-desc">무인양품ㅣ플레이타임 챔피언</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--transparent" data-id="" data-x="0" data-y="0">
                <span class="floor-guide-floor-name english"></span>
                <span class="floor-guide-floor-desc"></span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--transparent" data-id="" data-x="0" data-y="0">
                <span class="floor-guide-floor-name english"></span>
                <span class="floor-guide-floor-desc"></span>
            </div>
        </div>
        <div class="right-part">2</div>
    </div>
</div>`;